(function () {
  const SELECTOR_CUSTOM = '.literie-ways-to-earn__card';
  const SELECTOR_RIVO = '[id^="rivo-earning-rule-"]';
  const COMPLETED_CLASS = 'literie-ways-to-earn__card--completed';

  function syncCompleted() {
    const customCards = document.querySelectorAll(SELECTOR_CUSTOM);
    const rivoCards = document.querySelectorAll(SELECTOR_RIVO);
    if (!customCards.length || !rivoCards.length) return;

    customCards.forEach((card, idx) => {
      const rivoTarget = rivoCards[idx];
      if (!rivoTarget) return;
      // Every Rivo card contains an empty, hidden .rivo-completed div; the
      // actual completion signal is Alpine binding the `completed` class on
      // the card and un-hiding that div for the logged-in customer.
      const completedLabel = rivoTarget.querySelector('.rivo-completed');
      const completed =
        rivoTarget.classList.contains('completed') ||
        (!!completedLabel && getComputedStyle(completedLabel).display !== 'none');
      card.classList.toggle(COMPLETED_CLASS, completed);
    });
  }

  function wire() {
    const customCards = document.querySelectorAll(SELECTOR_CUSTOM);
    if (!customCards.length) return false;

    const rivoCards = document.querySelectorAll(SELECTOR_RIVO);
    if (!rivoCards.length) return false;

    let wiredAny = false;

    customCards.forEach((card, idx) => {
      if (card.dataset.literieWired === '1') return;

      const rivoTarget = rivoCards[idx];
      if (!rivoTarget) return;

      const trigger = (e) => {
        if (card.tagName === 'A' && card.getAttribute('href')) return;
        e.preventDefault();
        rivoTarget.click();
      };

      card.addEventListener('click', trigger);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          trigger(e);
        }
      });

      if (card.tagName !== 'A' && card.tagName !== 'BUTTON') {
        if (!card.hasAttribute('role')) card.setAttribute('role', 'button');
        if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
      }

      card.dataset.literieWired = '1';
      wiredAny = true;
    });

    return wiredAny;
  }

  function init() {
    wire();
    syncCompleted();

    // Stay subscribed even after wiring: Rivo fills in the customer's
    // completed actions asynchronously, and they can change without a page
    // reload (e.g. completing an action through the Rivo modal). Alpine
    // applies the completed state via class/style attribute changes, so
    // childList alone would miss it.
    const observer = new MutationObserver(() => {
      wire();
      syncCompleted();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
